(function () {
    "use strict";

    let cachedSearchResults = {};

    async function negarshop_search_in_site(query, terms = [], options = {
        post_type: 'product',
        in_stock: false,
        results_types: ['posts'],
        limit: 10
    }) {

        const formData = new URLSearchParams();
        formData.append('action', 'negarshop_ajax_search');
        formData.append('s', query);
        formData.append('terms', terms.join(','));
        formData.append('in_stock', options.in_stock);
        formData.append('type', options.post_type);
        formData.append('results_types', options.results_types);
        formData.append('limit', options.limit);

        return new Promise((resolve, reject) => {
            if (cachedSearchResults[formData]) {
                resolve(cachedSearchResults[formData]);
                return;
            }

            fetch(NS_OBJ.ajax_url, {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: formData
            }).then(res => res.json()).then(res => {
                cachedSearchResults[formData] = res;
                resolve(res);
            }).catch(reject);
        });
    }

    window.negarshop_search_in_site = negarshop_search_in_site;

    let searchTimer;

    document.addEventListener("click", function (e) {
        const isOverlayClick = e.target.classList.contains('ns-search-overlay');
        const $el = e.target.closest('.search-form-widget');
        if ($el && !isOverlayClick) return;

        document.body.classList.remove('ns-search-overlay-active');
        document.querySelectorAll('.search-form-widget.is-focused').forEach(el => {
            el.classList.remove('is-focused');
            const input = el.querySelector('input.search-query-field');
            if (input) {
                input.blur();
            }
        });

        document.querySelectorAll('.search-form-widget .search-results-list').forEach(results => {
            results.classList.remove('show');
        });
    });

    document.addEventListener("focusin", function (e) {
        if (typeof e.target.closest !== 'function') return;
        const $el = e.target.closest('.search-form-widget .search-query-field');
        if (!$el) return;

        const widgetEl = $el.closest('.search-form-widget');
        widgetEl.querySelector('.search-results-list').classList.add('show');

        if (widgetEl.classList.contains('search-form-widget--overlay')) {
            widgetEl.classList.add('is-focused');
            document.body.classList.add('ns-search-overlay-active');
        }
    });
    document.addEventListener("negarshop:search", function (e) {
        const widgetEl = e.target.closest('.search-form-widget');
        if (!widgetEl) return;

        const searchQueryField = widgetEl.querySelector('input.search-query-field');
        const searchTermField = widgetEl.querySelector('.search-term-field');
        const searchStockField = widgetEl.querySelector('input[name="stock"]');
        const searchPostTypeField = widgetEl.querySelector('input[name="post_type"]');
        const searchQueryMinLength = parseInt(widgetEl.getAttribute('data-min-length') ?? 2);
        const searchResultsTypes = (widgetEl.getAttribute('data-results-types') ?? 'post').split(',');
        const searchResultsLimit = parseInt(widgetEl.getAttribute('data-results-limit') ?? 10);
        const searchResultsWrapper = widgetEl.querySelector('.search-results-list');

        const resultTemplates = {
            product: widgetEl.querySelector('template.search-result-type-product'),
            post: widgetEl.querySelector('template.search-result-type-post'),
            category: widgetEl.querySelector('template.search-result-type-category'),
            brand: widgetEl.querySelector('template.search-result-type-brand'),
            divider: widgetEl.querySelector('template.search-result-type-divider'),
            archive: widgetEl.querySelector('template.search-result-type-archive'),
        }

        if (!searchQueryField) return;

        const searchQuery = searchQueryField.value.trimEnd();

        if (searchQueryField.value.length < searchQueryMinLength) return;

        var searchTerms = [];
        if (searchTermField && searchTermField.value.length > 0) {
            searchTerms.push(searchTermField.value);
        }


        clearTimeout(searchTimer);
        widgetEl.classList.add('loading');

        const displayResults = (response) => {
            if (!response.success) {
                return;
            }
            if (!Array.isArray(response.data)) {
                return;
            }
            searchResultsWrapper.innerHTML = '';
            response.data.forEach(item => {
                const template = resultTemplates[item.type ?? 'product'] ?? resultTemplates.product;
                const clone = document.importNode(template.content, true);
                if (item.title && clone.querySelector('.title')) {
                    clone.querySelector('.title').innerText = item.title;
                }
                if (item.subtitle && clone.querySelector('.subtitle')) {
                    clone.querySelector('.subtitle').innerHTML = item.subtitle;
                }
                if (item.link && clone.querySelector('a.link')) {
                    clone.querySelector('a.link').setAttribute('href', item.link);
                }
                if (item.id && clone.querySelector('a.link')) {
                    clone.querySelector('a.link').setAttribute('data-id', item.id);
                }
                if (item.image && clone.querySelector('img.thumbnail')) {
                    clone.querySelector('img.thumbnail').setAttribute('src', item.image);
                    clone.querySelector('img.thumbnail')?.setAttribute('alt', item.title);
                } else {
                    clone.querySelector('img.thumbnail, figure')?.remove();
                }

                searchResultsWrapper.append(clone);
            });

            const template = resultTemplates.archive;
            const clone = document.importNode(template.content, true);
            clone.querySelector('.title').innerText = searchQuery;
            const shopURL = new URL(clone.querySelector('.view-all').getAttribute('href'));
            shopURL.searchParams.append('s', searchQuery);
            if (searchPostTypeField) {
                shopURL.searchParams.append('post_type', searchPostTypeField.value);
            }
            clone.querySelector('.view-all').setAttribute('href', shopURL.href);
            searchResultsWrapper.append(clone);

            searchResultsWrapper.classList.add('show');
        }

        searchTimer = setTimeout(function () {

            negarshop_search_in_site(searchQuery, searchTerms, {
                post_type: searchPostTypeField ? searchPostTypeField.value : 'post',
                in_stock: searchStockField.value ?? false,
                results_types: searchResultsTypes,
                limit: searchResultsLimit
            }).then(displayResults).catch(console.error).finally(() => {
                widgetEl.classList.remove('loading')
            });
        }, 1000);
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            const searchField = e.target.closest('.search-form-widget input.search-query-field');
            if (!searchField) return;

            const widgetEl = searchField.closest('.search-form-widget');
            if (widgetEl && widgetEl.classList.contains('search-form-widget--live-search')) {
                e.preventDefault();
                widgetEl.dispatchEvent(new Event('negarshop:search', {
                    bubbles: true
                }));
            }
        } else if (e.key === "Escape") {
            const activeWidget = document.querySelector('.search-form-widget.is-focused');
            if (activeWidget) {
                const input = activeWidget.querySelector('input.search-query-field');
                if (input) {
                    input.blur();
                }
                document.body.classList.remove('ns-search-overlay-active');
                activeWidget.classList.remove('is-focused');
                const results = activeWidget.querySelector('.search-results-list');
                if (results) {
                    results.classList.remove('show');
                }
            }
        }
    });

    document.addEventListener("keyup", function (e) {
        const searchField = e.target.closest('.search-form-widget input.search-query-field');
        if (!searchField) return;

        const widgetEl = searchField.closest('.search-form-widget');
        if (widgetEl && widgetEl.classList.contains('search-form-widget--live-search')) {
            widgetEl.dispatchEvent(new Event('negarshop:search', {
                bubbles: true
            }));
        }
    });
    document.addEventListener("change", function (e) {
        const $el = e.target.closest('.search-form-widget .search-term-field');
        if (!$el) return;

        const widgetEl = $el.closest('.search-form-widget');
        if (widgetEl && widgetEl.classList.contains('search-form-widget--live-search')) {
            widgetEl.dispatchEvent(new Event('negarshop:search', {
                bubbles: true
            }));
        }
    });
    document.addEventListener("click", function (e) {
        const $el = e.target.closest('.search-form-widget .search-form-trigger');
        if (!$el) return;

        const widgetEl = $el.closest('.search-form-widget');
        if (widgetEl && widgetEl.classList.contains('search-form-widget--live-search')) {
            e.preventDefault();
            widgetEl.dispatchEvent(new Event('negarshop:search', {
                bubbles: true
            }));
        }
    });
    document.addEventListener("submit", function (e) {
        const $el = e.target.closest('.search-form-widget .search-form');
        if (!$el) return;

        const widgetEl = $el.closest('.search-form-widget');
        if (widgetEl && widgetEl.classList.contains('search-form-widget--live-search')) {
            e.preventDefault();
            widgetEl.dispatchEvent(new Event('negarshop:search', {
                bubbles: true
            }));
        }
    });


    // Handle modal mode.

    document.addEventListener("click", function (e) {
        const $el = e.target.closest('.search-form-widget .modal-trigger');
        if (!$el) return;
        const widget = document.querySelector('.search-form-widget')
        const modal = document.querySelector('#site-offcanvas-canvas .modal-search-widget');

        if (modal && widget) {
            modal.innerHTML = widget.outerHTML;
            // Add shortcut badge to the modal search inputs as well
            addShortcutBadges(modal);
        }
    });

    // Helper to dynamically add shortcut indicator badges to search inputs
    function addShortcutBadges(container = document) {
        const isMac = typeof window !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.userAgent || '');
        const shortcutText = isMac ? '⌘K' : 'Ctrl+F';

        container.querySelectorAll('.search-form-widget .over-input-group').forEach(group => {
            // Check if already added to avoid duplicates
            if (!group.querySelector('.search-shortcut-kbd')) {
                const kbd = document.createElement('kbd');
                kbd.className = 'search-shortcut-kbd';
                kbd.textContent = shortcutText;

                // Insert before search trigger button or loading icon
                const trigger = group.querySelector('.search-form-trigger, .loading-icon');
                if (trigger) {
                    group.insertBefore(kbd, trigger);
                } else {
                    group.appendChild(kbd);
                }
            }
        });
    }

    // Initialize shortcut badges on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => addShortcutBadges());
    } else {
        addShortcutBadges();
    }

    // Helper to find the best visible search input field to focus
    function findSearchInput() {
        // First try to find a visible input in our custom search widget
        let input = Array.from(document.querySelectorAll('.search-form-widget input.search-query-field'))
            .find(el => {
                const offcanvas = el.closest('.offcanvas');
                if (offcanvas && !offcanvas.classList.contains('show')) {
                    return false;
                }
                return el.offsetWidth > 0 || el.offsetHeight > 0;
            });
        
        // Fallback to other standard search forms if no widget is visible
        if (!input) {
            input = Array.from(document.querySelectorAll('.woocommerce-product-search input.search-field, form.search-form input[name="s"]'))
                .find(el => {
                    const offcanvas = el.closest('.offcanvas');
                    if (offcanvas && !offcanvas.classList.contains('show')) {
                        return false;
                    }
                    return el.offsetWidth > 0 || el.offsetHeight > 0;
                });
        }
        return input;
    }

    // Keyboard shortcut handler for search focus (Cmd+K on Mac, Ctrl+F on Windows/Linux)
    document.addEventListener("keydown", function (e) {
        const isMac = typeof window !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.userAgent || '');
        const isCmdK = isMac && e.metaKey && e.key.toLowerCase() === 'k';
        const isCtrlF = !isMac && e.ctrlKey && e.key.toLowerCase() === 'f';

        if (isCmdK || isCtrlF) {
            const searchInput = findSearchInput();
            if (searchInput) {
                e.preventDefault();
                searchInput.focus();
                searchInput.select();
            } else {
                // If search form is currently hidden in popup mode, trigger the offcanvas search modal
                const visibleTrigger = Array.from(document.querySelectorAll('.search-form-widget .modal-trigger'))
                    .find(el => {
                        const offcanvas = el.closest('.offcanvas');
                        if (offcanvas && !offcanvas.classList.contains('show')) {
                            return false;
                        }
                        return el.offsetWidth > 0 || el.offsetHeight > 0;
                    });
                if (visibleTrigger) {
                    e.preventDefault();
                    visibleTrigger.click();
                }
            }
        }
    });

    // Auto-focus search input when the site search offcanvas is shown
    document.addEventListener('shown.bs.offcanvas', function (e) {
        const offcanvas = e.target.closest('#site-offcanvas-canvas');
        if (offcanvas) {
            const searchInput = offcanvas.querySelector('input.search-query-field');
            if (searchInput) {
                searchInput.focus();
                searchInput.select();
            }
        }
    });
})();
